import { CCTPUnifiedAssets, Chain, MappedCCTPAssets } from "../_reducers/wallet.reducer";

export const actionTypes = {
  SAVE_CHAINS: 'SAVE_CHAINS',
  SAVE_USER_ASSETS: 'SAVE_USER_ASSETS',
  SAVE_CCTP_ASSETS: 'SAVE_CCTP_ASSETS',
  SAVE_CCTP_UNIFIED_ASSETS: 'SAVE_CCTP_UNIFIED_ASSETS',
};

/**
 * Save chains
 */
export const saveChains = (data: Chain[]) => (dispatch) => {
  dispatch({ type: actionTypes.SAVE_CHAINS, data });
}

export const saveUserAssets = (data) => (dispatch) => {
  dispatch({ type: actionTypes.SAVE_USER_ASSETS, data: data });
};

export const saveCCTPAssets = (cctp: MappedCCTPAssets, unified: CCTPUnifiedAssets[]) => (dispatch) => {
  dispatch({ type: actionTypes.SAVE_CCTP_ASSETS, data: cctp });
  dispatch({ type: actionTypes.SAVE_CCTP_UNIFIED_ASSETS, data: unified });
}
